/**
 * Primary front-end script.
 *
 * Primary JavaScript file. Any includes or anything imported should
 * be filtered through this file and eventually saved back into the
 * `/dist/js/app.js` file.
 *
 * @package   Codeable
 * @author    John Leskas, Panagiotis Synetos, Spyros Vlachopoulos <panagiotis.synetos@gmail.com>
 * @copyright 2019 John Leskas, Panagiotis Synetos, Spyros Vlachopoulos
 * @license   https://www.gnu.org/licenses/gpl-2.0.html GPL-2.0-or-later
 * @link      https://codeable.io
 */

/**
 * Modules Import
 */
import {searchToggle} from './modules/searchToggle'; // Search Toggle functionality
import {blogMenuMobile} from './modules/blogMenuMobile'; // Blog Menu mobile functionality
import {mobileMenu} from './modules/mobileMenu'; // Mobile Menu functionality
import {pricingMatrix} from './modules/pricingMatrix' // Pricing Matrix functionality
import {accordion} from './modules/accordion' // Accordion functionality
import {faq} from './modules/faq' // FAQ functionality
import {process} from './modules/process' // Process functionality
import {modal} from './modules/modal' // Modal functionality
import {slider} from './modules/slider' // Slider functionality
import {team} from './modules/team' // Slider functionality
import {sticky} from './modules/sticky' // Slider functionality
import {serviceCard} from './modules/serviceCard' // Slider functionality
import {toggleSelection} from './modules/toggle-selection' // Toggle selection functionality
import {loadMorePortfolioItems} from './modules/load-more-portfolio-items'
import Tune from "./modules/referral/tune"; // Load more portfolio items functionality

/**
 * A simple immediately-invoked function expression to kick-start
 * things and encapsulate our code.
 *
 * @since  1.0.0
 * @access public
 * @return void
 */
(function () {

	// Search Toggle functionality
	searchToggle();

	// Mobile Menu functionality
	mobileMenu();

	// Blog Menu Mobile functionality
	blogMenuMobile();

	// Pricing Matrix functionality
	pricingMatrix();

	// Accordion functionality
	accordion();

	// Process functionality
	process();

	// FAQ functionality
	faq();

	// Modal functionality
	modal();

	// Slider functionality
	slider();

	// Team functionality
	team();

	// Sticky functionality
	sticky();

	// Service Card functionality
	serviceCard();

	// Toggle tab functionality
	toggleSelection('.js-toggle-tab-nav', '.tab-content-item', '.tab-nav-item');

	loadMorePortfolioItems('.js-load-more-portfolio-items');

	Tune.init();


})();
